import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    // 1. Reset window scroll immediately
    window.scrollTo(0, 0);

    // 2. Reset main container scroll if it exists
    const container = document.querySelector(".container");
    if (container) {
      container.scrollTop = 0;
    }

    // 3. Run again after layout settles (fixes navbar shifts & async content)
    const layoutFix = setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "instant" });

      if (container) {
        container.scrollTo({ top: 0, behavior: "instant" });
      }
    }, 80); // 60–100ms is optimal

    return () => clearTimeout(layoutFix);
  }, [pathname]);

  return null;
}
